import { useState } from 'react';
import ProfileAccountDetails from './ProfileAccountDetails';
import ProfileDocuments from './ProfileDocuments';
import useIndustries from '../../../customhooks/industries/useIndustries';
import useBusinessTypes from '../../../customhooks/businesstypes/useBusinesstypes';
import useCountries from '../../../customhooks/useCountries';
import { useUserProfile } from '../../../customhooks/useUserProfile';
import ChangePassword from './ChangePassword';
import { SettingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import CompanyLogo from './CompanyLogo';

const UserProfileSettings = () => {
    const { industries, isIndustriesLoading } = useIndustries();
    const { businessTypes, isBusinessTypesLoading } = useBusinessTypes();
    const { countries, isCountriesLoading } = useCountries();
    const { isLoading, userDetails } = useUserProfile();

    const ProfileTabs = [
        { key: 'profile', label: 'profile page', allowView: true }
    ];

    const [selected, setSelected] = useState<typeof ProfileTabs[number]['key']>(
        ProfileTabs[0]['key']
    );

    console.log(userDetails?.role?.toLowerCase());
    return (
        <div>
            <Spin
                fullscreen
                spinning={isLoading}
                delay={500}
                indicator={
                    <SettingOutlined
                        style={{ fontSize: 100, color: '#329FC1' }}
                        spin
                    />
                }
            />

            {userDetails &&
                !isLoading &&
                !isCountriesLoading &&
                !isBusinessTypesLoading && (
                    <div className='flex flex-col gap-[10px] px-5 lg:px-0 bg-transparent pb-10 mt-4 lg:mt-0'>
                        <ProfileAccountDetails
                            {...{
                                userDetails,
                                countries,
                                isCountriesLoading,
                                isBusinessTypesLoading,
                                businessTypes,
                                industries,
                                isIndustriesLoading
                            }}
                        />

                        <CompanyLogo />

                        {(userDetails?.role?.toLowerCase() === 'admin' ||
                            userDetails?.role?.toLowerCase() === 'owner') && (
                            <ProfileDocuments {...{ userDetails }} />
                        )}

                        <ChangePassword />
                    </div>
                )}
        </div>
    );
};

export default UserProfileSettings;
